import { useState } from 'react';
import PropTypes from 'prop-types';
import IconSvg from 'Components/IconSvg';

const Select = ({ onSelect, options, translateOption, value }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (event) => {
    event.preventDefault();
    isOpen ? handleClose() : handleOpen();
  };

  const handleOpen = () => {
    setIsOpen(true);
    document.addEventListener('click', handleClose, { capture: true });
  };

  const handleClose = () => {
    setIsOpen(false);
    document.removeEventListener('click', handleClose, { capture: true });
  };

  const handleSelect = (option) => {
    onSelect(option);
    handleClose();
  };

  return (
    <div className={`select ${isOpen ? 'isOpen' : ''}`}>
      <div className="select__header" onClick={handleClick}>
        <span className="select__text">{translateOption(value)}</span>
        <span className="select__icon">
          <IconSvg type="arrowDown" />
        </span>
      </div>
      <ul className="select__options">
        {options.map((option) => (
          <li
            className={value === option ? 'active' : ''}
            key={option}
            onClick={() => handleSelect(option)}
          >
            {translateOption(option)}
          </li>
        ))}
      </ul>
    </div>
  );
};

Select.propTypes = {
  onSelect: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  translateOption: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

Select.defaultProps = {};

export default Select;
